module.exports = __webpack_public_path__ + "static/media/filter_icon.2c5325d2.svg";